
var debug = require('debug')('CRMMap:Pins');


const Pininfo = require('./PinInfo');

class Pins {

    constructor(CRMMap) {
        this.CRMMap = CRMMap;
        this.pins = [];
        this.show_icon = false;
        this.show_pin = false;
        this.area_size = 0;
        this.pininfo = null
    }


    globaltopin(pin){
        pin.show_icon   =  this.show_icon ;
        pin.show_pin    = this.show_pin;
        pin.show_area   = (this.area_size > 0);
        pin.area_radius =  this.area_size;
        return pin;
    }

    openinfo(pin) {
        if (!this.pininfo) {
            this.pininfo = new Pininfo(this.CRMMap);
        }
       return this.pininfo.open(pin);

    }

    push(pin) {
        this.pins[pin.id] = this.globaltopin(pin);
        
        pin.addListener('click', (e)=> {
            debug(e);
           this.openinfo(pin);
          });


        return pin;
    }

    find(id) {
        return  (this.pins[id])? this.pins[id]:false;
    }

    delete(pin) {
        var id = pin.id;
        this.pins[id].delete();
        delete this.pins[id];
    }

    get(id) {
        if (pin = this.find(id)) {
            return pin;
        }

        var Pin = require('./Pin');
        var pin = new Pin(this.CRMMap, id);
        pin.setMap(this.CRMMap.map);
        this.push(pin);
        return pin;
    }

    markall() {

        var promises = this.pins.map( (data)=> {
            return new Promise( (resolve, reject) =>{
                data.mark();
                return resolve();
            });
        });

        return Promise.all(promises);

    }

    deletemarked() {
        var self = this;
        this.pins.forEach((pin) => {
            if (pin.marked()) {
                self.delete(pin);
            }
        });
        return this;
    }

    setall(show_icon, show_pin, area_size) {

        this.show_icon =  show_icon ;
        this.show_pin = show_pin;
        this.area_size = area_size;


        this.pins.forEach((pin) => {
            this.globaltopin(pin);
            pin.draw();
        });
    }

    heatMapData() {
    
        return Promise.all(this.pins.map((data) => {
            //weight: data.icons.length,
            return { location: data.position, radius: 0.7 };
        }));
    }
}
module.exports = Pins;
